import { Loader as BaseLoader } from '../../mui-kit/loader';
import { styled } from '@innowise-group/mui-kit';

export const Loader = styled(BaseLoader)`
  margin: 0;
`;
